import BillVoteModel from './bill_vote_model';
export default Backbone.Collection.extend({
  model: BillVoteModel
});